import { useMemo } from "react";

import { generateBranchUrl } from "utils/urls";
import TableCellProjectRoot from "ds/components/Table/Row/CellProjectRoot";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Module } from "types/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { ModulesSuggestions } from "../../FiltersLayout/constants";
import useModulesAnalytics from "../../useModulesAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const ModulesTableProjectRootCell = ({
  item: module,
  ...cellProps
}: TableSimpleCellProps<Module>) => {
  const trackAnalytics = useModulesAnalytics();

  const isEmpty = !module.apiHost || !module.projectRoot;

  const projectRootFilterAction = useCellFilterAction({
    filterName: ModulesSuggestions.ProjectRoot,
    filterValue: module.projectRoot || "",
  });

  const actions = useMemo(
    () => (isEmpty ? undefined : [projectRootFilterAction]),
    [isEmpty, projectRootFilterAction]
  );

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}

      {module.apiHost && module.projectRoot && (
        <TableCellProjectRoot
          href={generateBranchUrl({
            apiHost: module.apiHost,
            branch: module.branch,
            namespace: module.namespace,
            repository: module.repository,
            repositoryURL: module.repositoryURL,
            provider: module.provider,
            projectRoot: module.projectRoot,
          })}
          onPress={() => trackAnalytics("Project root link clicked")}
        >
          {module.projectRoot}
        </TableCellProjectRoot>
      )}
    </TableSimpleCell>
  );
};

export default ModulesTableProjectRootCell;
